import { h } from 'preact';
import React, { Component } from 'react';

import { ButtonSettings } from './ButtonSettings';
import './Button.css';

export class Button extends Component {
  makeChoice = () => {
    const choice = this.props.component.settings.choice_option.data;
    if (choice.button_text) this.props.makeChoice(choice.button_text);
  }

  render() {
    const Settings = new ButtonSettings(this.props.component.settings);

    const styles = {
      ...Settings.padding,
      ...Settings.margin,
      ...Settings.border,
      ...Settings.font
    };

    /* WIDTH & HEIGHT */
    const { paddingLeft, paddingRight } = Settings.padding;
    const { marginLeft, marginRight } = Settings.margin;

    styles.width = Settings.width.type === 'auto' ? 'auto' : Settings.width.value + Settings.width.type;
    if (Settings.width.type === '%') {
      styles.width = `calc(${Settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`
    }

    styles.background = Settings.background;

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }
    const className = 'message-component message-button no-children';
    return (
      <button
        onClick={this.makeChoice}
        className={selected ? className + ' on-active' : className}
        path={path}
        style={styles}
        {...devActions}
      >
        {Settings.text}
      </button>
    );
  }
}